export default __webpack_public_path__ + "static/russel-fc0d8f9695b6edbf6c148af357de3123.jpg";